import { ShieldAlert } from 'lucide-react'

/**
 * Banner informativo antitruffa. Replicato dall'handoff:
 * "Mantenere come banner informativo statico, NON tooltip".
 */
export function AntitruffaBanner() {
  return (
    <aside className="flex items-start gap-3 rounded-xl border border-warning/30 bg-warning/10 p-4 text-sm">
      <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0 text-warning dark:text-white" />
      <div className="flex flex-col gap-1">
        <p className="font-semibold text-foreground">Attenzione alle truffe</p>
        <p className="leading-relaxed text-muted-foreground">
          Enermed non ti chiederà mai password, codici di accesso o dati di pagamento via
          telefono, SMS o email. In caso di dubbi, contattaci direttamente o segnala
          un’irregolarità sul nostro sito.
        </p>
        <a
          href="https://portaleantitruffa.it/enermed"
          target="_blank"
          rel="noreferrer"
          className="mt-1 inline-flex w-fit text-sm font-semibold text-secondary underline-offset-2 hover:underline"
        >
          Segnala una truffa →
        </a>
      </div>
    </aside>
  )
}
